import App from '@/pages/layouts/app.vue'
import {Link} from "@inertiajs/vue3";

import Card from "@/pages/components/card.vue";
import Permissions from "@/mixins/shared/permissions.js"
import Translate from "@/pages/translation/translate.vue"
import FormElements from "@/mixins/shared/formElements";

export default {
	components: {Card, App, Link, Translate},
	mixins : [Permissions, FormElements],

}